import axios, { AxiosResponse } from 'axios';
import CartCommodityItem from '@/classes/CartCommidityItem';
import Product from '@/classes/Product';
import ProductInterface from '@/interfaces/ProductInterface';
import { getCookie } from '@/helpers';
import CartInterface from '@/interfaces/CartInterface';

class CartAPI {
  public static mapResponse(response: AxiosResponse<any>): CartInterface {
    const cartResponseData = response?.data?.data?.cartData;
    const cartData = {
      commodity: [],
      nonCommodity: [],
      campaigns: [],
    } as CartInterface;

    Object.keys(cartResponseData.commodity).forEach((cartItemKey) => {
      const cartItemData = cartResponseData.commodity[cartItemKey];
      cartItemData.product = new Product(cartItemData.product as ProductInterface);

      cartData.commodity.push(new CartCommodityItem(cartItemKey, cartItemData));
    });

    return cartData;
  }

  static get(): Promise<CartInterface> {
    return new Promise((resolve, reject) => {
      let { ajaxUrl } = window.ioappConfig;
      const { protocol } = window.location;

      if (protocol !== 'https:') {
        ajaxUrl = ajaxUrl.replace('https://', 'http://');
      }

      axios.get(`${ajaxUrl}?action=cart`, {
        params: {
          endpoint: 'get',
          cartKey: getCookie('io_shop_cart'),
        },
      }).then((response) => {
        resolve(this.mapResponse(response) as CartInterface);
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static add(product: Product, params: Record<string, any>, cartItemKey: string | null): Promise<{
    cartData: CartInterface,
    cartEnabled: boolean,
    cartKey: string,
  }> {
    return new Promise((resolve, reject) => {
      let { ajaxUrl } = window.ioappConfig;
      const { protocol } = window.location;

      if (protocol !== 'https:') {
        ajaxUrl = ajaxUrl.replace('https://', 'http://');
      }

      axios.post(`${ajaxUrl}?action=cart`, {
        endpoint: 'add',
        cartKey: getCookie('io_shop_cart'),
        product: product.attributes,
        params,
        cartItemKey,
      }).then((response) => {
        resolve({
          cartData: this.mapResponse(response),
          cartEnabled: (response?.data?.data?.cartEnabled || false) as boolean,
          cartKey: (response?.data?.data?.cartKey || '') as string,
        });
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static remove(itemKey: string, product: Product): Promise<{
    cartData: CartInterface,
    cartEnabled: boolean,
    cartKey: string,
  }> {
    return new Promise((resolve, reject) => {
      let { ajaxUrl } = window.ioappConfig;
      const { protocol } = window.location;

      if (protocol !== 'https:') {
        ajaxUrl = ajaxUrl.replace('https://', 'http://');
      }

      axios.post(`${ajaxUrl}?action=cart`, {
        endpoint: 'remove',
        cartKey: getCookie('io_shop_cart'),
        itemKey,
        type: product.productType,
      }).then((response) => {
        resolve({
          cartData: this.mapResponse(response),
          cartEnabled: (response?.data?.data?.cartEnabled || false) as boolean,
          cartKey: (response?.data?.data?.cartKey || '') as string,
        });
      }).catch((e) => {
        reject(e);
      });
    });
  }

  static hasCartCookie(): boolean {
    return `${getCookie('io_shop_cart')}`.trim() !== '';
  }
}

export default CartAPI;
